import { listeningImage } from 'assets';
import Image from 'next/image';
import React from 'react';

const Listening = () => {
  return (
    <div className='w-full h-full bg-dropDownMenuBg rounded-3xl p-6 flex-col flex gap-6 justify-between '>
      <Image
        className='w-full  '
        alt='listeningImage'
        width={340}
        height={140}
        src={listeningImage}
      />
      <div className='flex flex-col gap-2'>
        <p className='text-lg leading-[26px] font-semibold text-white text-start'>
          Learn by Listening
        </p>
        <p className='text-sm font-normal leading-[22px] text-grayZl-600 text-start'>
          Turn traffic, walks, and coffee breaks into micro-mastery.
        </p>
      </div>
    </div>
  );
};

export default Listening;
